import { Form } from './components/form';
import { Containers } from './components/table';

import {
  PERMISSION_CREATE,
  PERMISSION_OBJ_CONTAINER,
  PERMISSION_READ,
  PERMISSION_UPDATE,
} from '@/constants/permissions';

export const states = [
  {
    name: 'base-layout.containers',
    url: '/containers',
    component: Containers,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_CONTAINER, PERMISSION_READ]],
    },
  },
  {
    name: 'base-layout.containers.create',
    url: '/new',
    component: Form,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_CONTAINER, PERMISSION_CREATE]],
    },
  },
  {
    name: 'base-layout.containers.edit',
    url: '/:containerId/edit',
    component: Form,
    data: {
      requiresAuth: true,
      permissions: [[PERMISSION_OBJ_CONTAINER, PERMISSION_UPDATE]],
    },
  },
];
